import { Layout } from "@components/site/Layout"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single", (props) => {
  return (
    <Layout>
      <ContentBlocks blocks={props.post?.contentBlocks} />
    </Layout>
  )
})
